var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 180,
    viewBox: "0 0 194 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 0.5,
    width: 179,
    height: 179,
    rx: 89.5,
    fill: "white",
    stroke: "#BA0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.9645 90.0585C94.1947 94.6834 100.06 96.0982 103.246 92.5279C114.191 80.2647 134.007 58.0228 139.87 51.1871C140.936 49.9435 140.869 48.0865 139.714 46.9244C138.544 45.746 136.66 45.6868 135.418 46.7894L94.2214 83.368C93.4422 84.0598 91.5158 84.6119 91.5158 84.6119L92.9645 90.0585Z",
    fill: "#202635"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9508 86.3276C92.3268 87.558 90.9124 93.4242 94.4819 96.6112C106.743 107.558 128.98 127.378 135.814 133.243C137.057 134.309 138.914 134.242 140.076 133.087C141.254 131.916 141.313 130.032 140.211 128.79L103.64 87.5847C102.948 86.8054 102.396 84.8785 102.396 84.8785L96.9508 86.3276Z",
    fill: "#202635"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0492 85.9729C101.673 87.2034 103.088 93.0695 99.5182 96.2566C87.2575 107.203 65.0203 127.024 58.186 132.888C56.9427 133.955 55.0861 133.887 53.9242 132.732C52.7461 131.562 52.6869 129.678 53.7892 128.436L90.3601 87.2301C91.0518 86.4507 91.6037 84.5239 91.6037 84.5239L97.0492 85.9729Z",
    fill: "#202635"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.035 90.4132C99.8053 95.0381 93.9404 96.4528 90.754 92.8826C79.8094 80.6194 59.9933 58.3774 54.1303 51.5417C53.0637 50.2982 53.1314 48.4412 54.2858 47.279C55.4562 46.1007 57.3401 46.0415 58.5818 47.144L99.7786 83.7226C100.558 84.4145 102.484 84.9665 102.484 84.9665L101.035 90.4132Z",
    fill: "#202635"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFail);
export default __webpack_public_path__ + "static/media/fail.26286b97.svg";
export { ForwardRef as ReactComponent };